import { memo } from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorStateProps {
  error: string;
  onRetry?: () => void;
  showRetry?: boolean;
}

const ErrorState = memo(({ error, onRetry, showRetry = false }: ErrorStateProps) => {
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-6">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800">
            Error loading requests
          </h3>
          <div className="mt-2 text-sm text-red-700">
            {error}
          </div>
          {showRetry && onRetry && (
            <div className="mt-4">
              <button
                onClick={onRetry}
                className="inline-flex items-center space-x-2 text-sm bg-red-100 text-red-800 hover:bg-red-200 px-3 py-2 rounded-md transition-colors"
              >
                <RefreshCw className="h-4 w-4" />
                <span>Try Again</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

ErrorState.displayName = 'ErrorState';

export default ErrorState;